import { INavData } from '@coreui/angular';

export const navItems = [

  {
    name: 'Admin users',
    url: '/admin-user',
    icon: 'icon-user-following',
    color: 'black'
  },


  {
    name: 'Entie users',
    url: '/users',
    icon: 'icon-people',
    color: 'black'
  },

  {
    name: 'Industries',
    url: '/industries',
    icon: 'fa fa-industry',
    color: 'black'

  },
  {
    name: 'Broadcast email',
    url: '/email',
    icon: 'icon-envelope-letter',
    color: 'black'
  },
 
  {
    name: 'Payment analytics',
    url: '/payment-analytics',
    icon: 'icon-credit-card',
    color: 'black'
  },

  {
    name: 'Tags',
    url: '/tag',
    icon: 'icon-tag ',
    color: 'black'
  },
  {
    name: 'Varify',
    url: '/subscription',
    icon: 'fa-check-circle',
    color: 'black'
  },
  {
    name: 'Rating',
    url: '/rating',
    icon: 'fa fa-star',
    color: 'black'
  },
  {
    name: "Article",
    url: '/blog',
    icon: 'fa fa-upload',
    color: 'black'
  },
  {
    name: "Blog category",
    url: '/blog/blog_category',
    icon: 'fa fa-upload',
    color: 'black'
  },
  {
    name: " Blogs",
    url: '/blog/blog',
    icon: 'fa fa-upload',
    color: 'black'
  }, 
  {
    name: "Sucess stories",
    url: '/blog/sucess_stories',
    icon: 'fa fa-upload',
    color: 'black'
  },
  {
    name: "Comments",
    url: '/blog/comments',
    icon: 'fa fa-star',
    color: 'black'
  },
];
